import moment from "moment";
import { convertToPercent, deepCopy, divide,
    getCorrectValue, getDayDateKey, round, setUpDate } from "../../../app/util";
import { useDataSummary } from "../../Tile/kpiService";
import dataService from "../../../services/data.service";
import { useSelector } from "react-redux";

export function getPickupData(data, columns, app_state) {
    let dataKey = "HotelTotal";
    let setup_data = [];
    data.map((item, index) => {
        let data_columns = [];
        columns.map(col => {
            let dataObj = { id: col.id };
            if (col.type === 'dateColumn') {

                dataObj = setUpDate(dataObj, item.index.date);
                if (app_state.workspace_controls.segmented_view) {
                    dataObj["segment"] = item.index.segment;
                }
            }
            if (col.type === 'dataColumn') {
                let dataMainKey = (app_state.workspace_controls.pickUpType === 'Standard') ? "current" : "primary";

                let { mainKey } = col;
                col.subcolumns.map(key => {
                    let value = key.value;
                    if (mainKey === "otb_sdly_diff") {
                        if (value === "Occ") {
                            dataObj[value] = convertToPercent(item[dataKey]["sdly"][value] - item[dataKey]["sdly_pickup"][value])
                        } else if (value == "ADR") {
                            dataObj[value] = round((item[dataKey]["sdly"]["Revenue"] - item[dataKey]["sdly_pickup"]["Revenue"]) / (item[dataKey]["sdly"]["Rooms"] - item[dataKey]["sdly_pickup"]["Rooms"]))
                        } else {
                            dataObj[value] = round(item[dataKey]["sdly"][value] - item[dataKey]["sdly_pickup"][value])
                        }
                    } else if (mainKey === "otb_difference") {
                        let key2 = (app_state.workspace_controls.pickUpType === 'Standard') ? "prior" : "pickup";

                        let adrRev = item[dataKey][dataMainKey]['Revenue'] - item[dataKey][key2]['Revenue'];
                        let adrRooms = item[dataKey][dataMainKey]['Rooms'] - item[dataKey][key2]['Rooms'];
                        if (value === "Occ") {
                            dataObj[value] = convertToPercent(item[dataKey][dataMainKey][value] - item[dataKey][key2][value])
                        } else if (value == "ADR") {
                            // dataObj[value] = round(item[dataKey][dataMainKey]["Revenue"] - item[dataKey]["prior"]["Rooms"])
                            let adrValue = round(adrRev / adrRooms);
                            dataObj[value] = (isNaN(adrValue)) ? 0 : round(parseFloat(adrRev / adrRooms))
                        } else {
                            dataObj[value] = round(item[dataKey][dataMainKey][value] - item[dataKey][key2][value])
                        }
                    } else if (mainKey === "otb_pickup") {
                        dataMainKey = (app_state.workspace_controls.pickUpType === 'Standard') ? "prior" : "pickup";
                        if (value === "Occ") {
                            dataObj[value] = convertToPercent(item[dataKey][dataMainKey][value]);
                        } else {
                            dataObj[value] = round(item[dataKey][dataMainKey][value]);
                        }
                    } else if (mainKey === "sdly_pickup") {
                        dataMainKey = mainKey;
                        if (value === "Occ") {
                            dataObj[value] = convertToPercent(item[dataKey][dataMainKey][value]);
                        } else {
                            dataObj[value] = round(item[dataKey][dataMainKey][value]);
                        }
                    } else if (mainKey === "sdly") {
                        dataMainKey = mainKey;
                        if (value === "Occ") {
                            dataObj[value] = convertToPercent(item[dataKey][dataMainKey][value]);
                        } else {
                            dataObj[value] = round(item[dataKey][dataMainKey][value]);
                        }
                    }
                    else if (item[dataKey][mainKey]) {

                        if (value === "Occ") {
                            dataObj[value] = convertToPercent(item[dataKey][dataMainKey][value]);
                        } else {
                            dataObj[value] = round(item[dataKey][dataMainKey][value]);
                        }
                    }
                })
            }
            data_columns.push(dataObj);
        })
        setup_data.push(data_columns);
    })
    return setup_data;
}


// RevPAR for one identifier block (current/prior/sdly/...). The OSR feed sends RevPAR = 0 on
// per-segment blocks, so segment callers pass force=true to always derive it from Revenue and
// capacity; hotel-level callers only derive under the Variable Capacity toggle (raw is valid
// otherwise). Falls back to the raw value when no capacity is available (e.g. the aggregated
// date='' rows from osrSegmentTotal, whose RevPAR is precomputed upstream).
export const blockRevPAR = (block, useVarCapacity, force = false, fallbackBlock = null) => {
    if (!block) return 0;
    const pickCap = (b) => (b ? (useVarCapacity ? (b.VCapacity || b.Capacity) : b.Capacity) : 0);
    const cap = pickCap(block) || pickCap(fallbackBlock);
    if (cap && (useVarCapacity || force) && block.Revenue !== undefined) {
        return getCorrectValue(block.Revenue) / cap;
    }
    return getCorrectValue(block.RevPAR);
};

// Occ (as a fraction, pre-convertToPercent) for one identifier block: Rooms / VCapacity when
// the Variable Capacity toggle is on, the feed's raw fixed-capacity Occ otherwise.
export const blockOcc = (block, useVarCapacity) => {
    if (!block) return 0;
    const cap = block.VCapacity || block.Capacity;
    if (useVarCapacity && cap && block.Rooms !== undefined) {
        return block.Rooms / cap;
    }
    return getCorrectValue(block.Occ);
};

// get PickData for intellimerge
export const getPickupDataInt = (mainKey, id, tileName, key, index, dataKey, auth, app_state, tileData, ui_state = {}) => {
    let otbPickupData = deepCopy(tileData); //deepCopy(dataService.getSeriesById("OSR").data.data);
    let dataMainKey = (app_state.workspace_controls.pickUpType === 'Standard') ? "current" : "primary";
    if (mainKey === "otb_pickup") {
        dataMainKey = (app_state.workspace_controls.pickUpType === 'Standard') ? "prior" : "pickup";
    }
    const { dayDate } = app_state.workspace_controls;
    let dataObj = {};
    let value = key.value;
    let otbPickupDatakey = otbPickupData[dataKey];
    let pickupDataMain = otbPickupDatakey[dataMainKey];
    // let pickupPrimary = otbPickupDatakey["primary"];
    let pickupSdly = (dayDate === "day") ? otbPickupDatakey["sdly"] : otbPickupDatakey["sdtly"] ;
    let pickupData = (app_state.workspace_controls.pickUpType === 'Standard') ? otbPickupDatakey["prior"] : otbPickupDatakey["pickup"]; //otbPickupDatakey["pickup"];
    let pickupSdlyPickup = (dayDate === "day") ? otbPickupDatakey["sdly_pickup"] : otbPickupDatakey["sdtly_pickup"];
    const useVarCapacityInt = !!(ui_state?.showVariableCapacity);
    if (otbPickupData) {
        if (mainKey === "otb_sdly_diff") {
            if (value === "Occ") {
                dataObj[value] = convertToPercent(blockOcc(pickupSdly, useVarCapacityInt) - blockOcc(pickupSdlyPickup, useVarCapacityInt))
            } else if (value == "ADR") {
                dataObj[value] = round((pickupSdly["Revenue"] - pickupSdlyPickup["Revenue"]) / (pickupSdly["Rooms"] - pickupSdlyPickup["Rooms"]))
            } else if (value === "RevPAR") {
                dataObj[value] = round(blockRevPAR(pickupSdly, useVarCapacityInt) - blockRevPAR(pickupSdlyPickup, useVarCapacityInt));
            } else {
                dataObj[value] = round(pickupSdly[value] - pickupSdlyPickup[value])
            }
        } else if (mainKey === "otb_difference") {
            let key2 = (app_state.workspace_controls.pickUpType === 'Standard') ? "prior" : "pickup";
            let adrRev = pickupDataMain['Revenue'] - otbPickupDatakey[key2]['Revenue'];
            let adrRooms = pickupDataMain['Rooms'] - otbPickupDatakey[key2]['Rooms'];
            if (value === "Occ") {
                dataObj[value] = convertToPercent(blockOcc(pickupDataMain, useVarCapacityInt) - blockOcc(otbPickupDatakey[key2], useVarCapacityInt))
                // Indicator shows only when the fixed-vs-variable capacity GAP itself differs
                // between the two pickup snapshots (same rule as pickup_report_functions.js's
                // variance_pickup on Pickup By Segment) — not just whenever either snapshot
                // alone has a fixed/variable mismatch.
                const cap1 = pickupDataMain?.Capacity;
                const vc1 = pickupDataMain?.VCapacity;
                const cap2 = otbPickupDatakey[key2]?.Capacity;
                const vc2 = otbPickupDatakey[key2]?.VCapacity;
                if ([cap1, vc1, cap2, vc2].every(v => typeof v === 'number')) {
                    dataObj._vcap = useVarCapacityInt ? (vc1 || cap1) : cap1;
                    dataObj._vcapLabel = 'Variable Capacity';
                    dataObj._vcapDiffers = (cap1 - vc1) !== (cap2 - vc2);
                }
            } else if (value == "ADR") {
                let adrValue = round(divide(adrRev,adrRooms));
                dataObj[value] = (isNaN(adrValue)) ? 0 : round(parseFloat(divide(adrRev,adrRooms)))
            } else if (value === "RevPAR") {
                dataObj[value] = round(blockRevPAR(pickupDataMain, useVarCapacityInt) - blockRevPAR(otbPickupDatakey[key2], useVarCapacityInt));
            } else {
                dataObj[value] = round(pickupDataMain[value] - otbPickupDatakey[key2][value])
            }
        } else if (mainKey === "otb_pickup") {
            // dataMainKey = (app_state.workspace_controls.pickUpType === 'Standard') ? "prior" : "pickup";
            if (value === "Occ") {
                dataObj[value] = convertToPercent(blockOcc(pickupDataMain, useVarCapacityInt));
            } else if (value === "RevPAR") {
                dataObj[value] = round(blockRevPAR(pickupDataMain, useVarCapacityInt));
            } else {
                dataObj[value] = round(pickupDataMain[value]);
            }
        } else if (mainKey === "sdly_pickup") {
            mainKey = getDayDateKey(dayDate, mainKey);
            dataMainKey = mainKey;
            if (value === "Occ") {
                dataObj[value] = convertToPercent(blockOcc(pickupSdlyPickup, useVarCapacityInt));
            } else if (value === "RevPAR") {
                dataObj[value] = round(blockRevPAR(pickupSdlyPickup, useVarCapacityInt));
            } else {
                dataObj[value] = round(pickupSdlyPickup[value]);
            }
        } else if (mainKey === "sdly") {
            mainKey = getDayDateKey(dayDate, mainKey);
            dataMainKey = mainKey;
            const useVarCapacity = !!(ui_state?.showVariableCapacity);
            if (value === "Occ") {
                const vCap = pickupSdly?.VCapacity || pickupSdly?.Capacity;
                if (useVarCapacity && vCap && pickupSdly?.Rooms !== undefined) {
                    dataObj[value] = convertToPercent(pickupSdly.Rooms / vCap);
                } else {
                    dataObj[value] = convertToPercent(pickupSdly[value]);
                }
                if (vCap) {
                    dataObj._vcap = useVarCapacity ? vCap : pickupSdly.Capacity;
                    dataObj._vcapLabel = (useVarCapacity && pickupSdly.VCapacity) ? 'Variable Capacity' : 'Capacity';
                    dataObj._vcapDiffers = !!(pickupSdly.VCapacity && pickupSdly.VCapacity !== pickupSdly.Capacity);
                }
            } else if (value === "RevPAR") {
                const vCap = pickupSdly?.VCapacity || pickupSdly?.Capacity;
                if (useVarCapacity && vCap && pickupSdly?.Revenue !== undefined) {
                    dataObj[value] = pickupSdly.Revenue / vCap;
                } else {
                    dataObj[value] = round(pickupSdly[value]);
                }
            } else {
                dataObj[value] = round(pickupSdly[value]);
            }
        }else if (mainKey === "pickup") {
            // debugger;
            mainKey = (app_state.workspace_controls.pickUpType === 'Standard') ? "prior" : "pickup";
            dataMainKey = mainKey;
            const useVarCapacity = !!(ui_state?.showVariableCapacity);
            if (value === "Occ") {
                const vCap = pickupData?.VCapacity || pickupData?.Capacity;
                if (useVarCapacity && vCap && pickupData?.Rooms !== undefined) {
                    dataObj[value] = convertToPercent(pickupData.Rooms / vCap);
                } else {
                    dataObj[value] = convertToPercent(blockOcc(pickupData, useVarCapacityInt));
                }
                if (vCap) {
                    dataObj._vcap = useVarCapacity ? vCap : pickupData.Capacity;
                    dataObj._vcapLabel = (useVarCapacity && pickupData.VCapacity) ? 'Variable Capacity' : 'Capacity';
                    dataObj._vcapDiffers = !!(pickupData.VCapacity && pickupData.VCapacity !== pickupData.Capacity);
                }
            } else if (value === "RevPAR") {
                const vCap = pickupData?.VCapacity || pickupData?.Capacity;
                if (useVarCapacity && vCap && pickupData?.Revenue !== undefined) {
                    dataObj[value] = pickupData.Revenue / vCap;
                } else {
                    dataObj[value] = round(blockRevPAR(pickupData, useVarCapacityInt));
                }
            } else {
                dataObj[value] = round(pickupData[value]);
            }
        }
        else if (otbPickupData && tileName === "pickup") {
            const useVarCapacity = !!(ui_state?.showVariableCapacity);
            if (value === "Occ") {
                const vCap = pickupDataMain?.VCapacity || pickupDataMain?.Capacity;
                if (useVarCapacity && vCap && pickupDataMain?.Rooms !== undefined) {
                    dataObj[value] = convertToPercent(pickupDataMain.Rooms / vCap);
                } else {
                    dataObj[value] = convertToPercent(pickupDataMain[value]);
                }
                if (vCap) {
                    dataObj._vcap = useVarCapacity ? vCap : pickupDataMain.Capacity;
                    dataObj._vcapLabel = (useVarCapacity && pickupDataMain.VCapacity) ? 'Variable Capacity' : 'Capacity';
                    dataObj._vcapDiffers = !!(pickupDataMain.VCapacity && pickupDataMain.VCapacity !== pickupDataMain.Capacity);
                }
            } else if (value === "RevPAR") {
                const vCap = pickupDataMain?.VCapacity || pickupDataMain?.Capacity;
                if (useVarCapacity && vCap && pickupDataMain?.Revenue !== undefined) {
                    dataObj[value] = pickupDataMain.Revenue / vCap;
                } else {
                    dataObj[value] = round(pickupDataMain[value]);
                }
            } else {
                dataObj[value] = round(pickupDataMain[value]);
            }
        }
    }
    return dataObj;
}





export const getPickupDataInt_segment = (mainKey, id, tileName, key, index, dataKey, auth, app_state, pickupData, ui_state = {}) => {

    // console.log("pickupData => ",pickupData);
    // debugger;
    // let otbPickupData = deepCopy(dataService.getSeriesById("OSR").data.data);
    let {pickUpType} = app_state.workspace_controls;
    let value = key.value;
    let dataMainKey = (pickUpType === 'Standard') ? "current" : "primary";

    let dataObj = {};
    let data = pickupData[dataKey] ? pickupData[dataKey] : undefined;
    // Segment blocks come in with RevPAR = 0 from the feed — always derive it (force = true),
    // using the segment's primary block as capacity fallback for identifiers missing their own.
    // Occ is only overridden while the Variable Capacity toggle is ON (Rooms / VCapacity);
    // with the toggle off the original raw-Occ expressions run unchanged.
    const useVarCapacitySeg = !!(ui_state?.showVariableCapacity);
    const segRevPAR = (block) => blockRevPAR(block, useVarCapacitySeg, true, data ? data.primary : null);
    const segOcc = (block) => blockOcc(block, true);

    if (mainKey === "otb_sdly_diff" && data) {
        let dataSdly = data["sdly"];
        let dataSdlyPickup = data["sdly_pickup"];
        if (value === "Occ") {
            dataObj[value] = useVarCapacitySeg
                ? convertToPercent(segOcc(dataSdly) - segOcc(dataSdlyPickup))
                : convertToPercent(dataSdly[value] - dataSdlyPickup[value])
        } else if (value == "ADR") {
            dataObj[value] = round((dataSdly["Revenue"] - dataSdlyPickup["Revenue"]) / (dataSdly["Rooms"] - dataSdlyPickup["Rooms"]))
        } else if (value === "RevPAR") {
            dataObj[value] = round(segRevPAR(dataSdly) - segRevPAR(dataSdlyPickup));
        } else {
            dataObj[value] = round(dataSdly[value] - dataSdlyPickup[value])
        }
    } else if (mainKey === "otb_difference" && data) {
            let dataMain = data[dataMainKey];
            let key2 = (pickUpType === 'Standard') ? "prior" : "pickup";
            let dataKey2 = data[key2];
            let adrRev = dataMain['Revenue'] - dataKey2['Revenue'];
            let adrRooms = dataMain['Rooms'] - dataKey2['Rooms'];
            if (value === "Occ") {
                dataObj[value] = useVarCapacitySeg
                    ? convertToPercent(segOcc(dataMain) - segOcc(dataKey2))
                    : convertToPercent(getCorrectValue(dataMain[value]) - getCorrectValue(dataKey2[value]))
                // Same capacity-gap-difference rule as the non-segmented getPickupDataInt above.
                const cap1 = dataMain?.Capacity;
                const vc1 = dataMain?.VCapacity;
                const cap2 = dataKey2?.Capacity;
                const vc2 = dataKey2?.VCapacity;
                if ([cap1, vc1, cap2, vc2].every(v => typeof v === 'number')) {
                    dataObj._vcap = useVarCapacitySeg ? (vc1 || cap1) : cap1;
                    dataObj._vcapLabel = 'Variable Capacity';
                    dataObj._vcapDiffers = (cap1 - vc1) !== (cap2 - vc2);
                }
            } else if (value == "ADR") {
                let adrValue = round(adrRev / adrRooms);
                dataObj[value] = (isNaN(adrValue)) ? 0 : round(parseFloat(adrRev / adrRooms))
            } else if (value === "Rooms") {
                dataObj[value] = getCorrectValue(dataMain[value]) - getCorrectValue(dataKey2[value]);
            } else if (value === "RevPAR") {
                dataObj[value] = round(segRevPAR(dataMain) - segRevPAR(dataKey2));
            } else {
                dataObj[value] = round(dataMain[value] - dataKey2[value])
            }

    } else if (mainKey === "otb_pickup" && data) {
        dataMainKey = (pickUpType === 'Standard') ? "prior" : "pickup";
        let mainKeyData = data[dataMainKey];
        if (value === "Occ") {
            dataObj[value] = useVarCapacitySeg ? convertToPercent(segOcc(mainKeyData)) : convertToPercent(mainKeyData[value]);
        } else if (value === "RevPAR") {
            dataObj[value] = round(segRevPAR(mainKeyData));
        } else {
            dataObj[value] = round(mainKeyData[value]);
        }
    } else if (mainKey === "sdly_pickup" && data) {
        dataMainKey = mainKey;
        let mainKeyData = data[dataMainKey];
        if (value === "Occ") {
            dataObj[value] = useVarCapacitySeg ? convertToPercent(segOcc(mainKeyData)) : convertToPercent(mainKeyData[value]);
        } else if (value === "RevPAR") {
            dataObj[value] = round(segRevPAR(mainKeyData));
        } else {
            dataObj[value] = round(mainKeyData[value]);
        }
    } else if (mainKey === "sdly" && data) {
        dataMainKey = mainKey;
        let mainKeyData = data[dataMainKey];
        if (value === "Occ") {
            dataObj[value] = useVarCapacitySeg ? convertToPercent(segOcc(mainKeyData)) : convertToPercent(mainKeyData[value]);
            const vCap = mainKeyData?.VCapacity || mainKeyData?.Capacity;
            if (vCap) {
                dataObj._vcap = useVarCapacitySeg ? vCap : mainKeyData.Capacity;
                dataObj._vcapLabel = (useVarCapacitySeg && mainKeyData.VCapacity) ? 'Variable Capacity' : 'Capacity';
                dataObj._vcapDiffers = !!(mainKeyData.VCapacity && mainKeyData.VCapacity !== mainKeyData.Capacity);
            }
        } else if (value === "RevPAR") {
            dataObj[value] = round(segRevPAR(mainKeyData));
        } else {
            dataObj[value] = round(mainKeyData[value]);
        }
    } else if (mainKey === "pickup" && data) {
        // pickup_prior column: "prior" (Standard) / "pickup" (Compare) block — distinct from the
        // generic tileName fallback's dataMainKey (which stays "current"/"primary"), matching
        // getPickupDataInt's non-segmented "pickup" branch.
        dataMainKey = (pickUpType === 'Standard') ? "prior" : "pickup";
        let mainKeyData = data[dataMainKey];
        if (value === "Occ") {
            dataObj[value] = useVarCapacitySeg ? convertToPercent(segOcc(mainKeyData)) : convertToPercent(mainKeyData[value]);
            const vCap = mainKeyData?.VCapacity || mainKeyData?.Capacity;
            if (vCap) {
                dataObj._vcap = useVarCapacitySeg ? vCap : mainKeyData.Capacity;
                dataObj._vcapLabel = (useVarCapacitySeg && mainKeyData.VCapacity) ? 'Variable Capacity' : 'Capacity';
                dataObj._vcapDiffers = !!(mainKeyData.VCapacity && mainKeyData.VCapacity !== mainKeyData.Capacity);
            }
        } else if (value === "RevPAR") {
            dataObj[value] = round(segRevPAR(mainKeyData));
        } else {
            dataObj[value] = round(mainKeyData[value]);
        }
    }
    else if (pickupData && tileName === "pickup") {
        if (data) {
            let mainKeyData = data[dataMainKey];
            if (value === "Occ") {
                dataObj[value] = useVarCapacitySeg ? convertToPercent(segOcc(mainKeyData)) : convertToPercent(mainKeyData[value]);
                const vCap = mainKeyData?.VCapacity || mainKeyData?.Capacity;
                if (vCap) {
                    dataObj._vcap = useVarCapacitySeg ? vCap : mainKeyData.Capacity;
                    dataObj._vcapLabel = (useVarCapacitySeg && mainKeyData.VCapacity) ? 'Variable Capacity' : 'Capacity';
                    dataObj._vcapDiffers = !!(mainKeyData.VCapacity && mainKeyData.VCapacity !== mainKeyData.Capacity);
                }
            } else if (value === "RevPAR") {
                dataObj[value] = round(segRevPAR(mainKeyData));
            } else {
                dataObj[value] = round(mainKeyData[value]);
            }
        }
    }

    return dataObj;

}